import Vue from 'vue';
import format from 'date-fns/format';

export const suppliersListingService = {
  async retrieveSuppliersList(activeInactive, sortOrder, paginationParam) {
    return Vue.axios
      .get('/suppliers/list', {
        params: {
          activeInactive,
          ...sortOrder,
          ...paginationParam
        }
      })
      .then(response => response.data);
  },

  async retrieveRecordCount(activeInactive, searchParam) {
    return Vue.axios
      .get('/suppliers/count-records', {
        params: {
          activeInactive,
          searchParam
        }
      })
      .then(response => response.data);
  },

  async downloadSuppliersXlsx(paginationParameters, sortingParameters, suppliersActiveFilter) {
    const response = await Vue.axios({
      url: `/suppliers/xlsx`,
      method: 'GET',
      params: {
        ...paginationParameters,
        ...sortingParameters,
        suppliersActiveFilter
      },
      responseType: 'blob'
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Suppliers-${format(new Date(), 'YYYY-MM-DD-HH-mm-ss')}.xlsx`);
    document.body.appendChild(link);
    link.click();
  }
};
